import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import { Modal } from "react-bootstrap";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import blogFetch from "../../axios/config";
import { getIdCompany } from "../../utils/constantes";
import RegisterSkuEquipment from "./RegisterSkuEquipment";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import "../../styles/Style.css";

function SkuEquipment() {
  const [equipments, setEquipments] = useState([]);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [skuId, setSkuequipment] = useState(0);
  const [loading, setLoading] = useState(false);
  const { useRef } = React;

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  const ref = useRef();

  useEffect(() => {
    getSkuEquipments();
  }, []);

  const getSkuEquipments = async () => {
    try {
      let response = await blogFetch.get(
        `/skuequipment?companyId=${getIdCompany()}`
      );
      let data = response.data;
      setEquipments(data);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteSkuEquipments = async (skE_PK_idSkuEquip) => {
    try {
      await blogFetch.delete(`/question/${skE_PK_idSkuEquip}`);
      getSkuEquipments();
    } catch (error) {
      console.error(error);
    }
  };

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterSkuEquipment ref={ref}></RegisterSkuEquipment>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.adicionar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addSkuEquipment();
                setLoading(false);
                setShowModalAdd(false);
                getSkuEquipments();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.adicionar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterSkuEquipment
            ref={ref}
            IdSkuEquip={skuId}
          ></RegisterSkuEquipment>
          
        </Modal.Body>{" "}
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalEdit(false)}
          >
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.editar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateSkuEquipment();
                setLoading(false);
                setShowModalEdit(false);
                getSkuEquipments();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.editar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalDelete = () => {
    return (
      <Modal show={showModalDelete} onHide={() => setShowModalDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.skuEquipamento.modal.deletar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body ref={ref} IdSkuEquip={skuId}>
          Deseja realmente inativar o Setor?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => showModalDelete(false)}
          >
             {language[selectedCountry.name].Cadastro.skuEquipamento.modal.deletar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                deleteSkuEquipments(skuId);
                setLoading(false);
                setShowModalEdit(false);
                getSkuEquipments();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
             {language[selectedCountry.name].Cadastro.skuEquipamento.modal.deletar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.skuEquipamento.title}
            </h3>
          </div>
          <div>
            <Button
              className="add_button"
              variant="primary"
              onClick={() => {
                modalAdd();
                setShowModalAdd(true);
              }}
            >
              {language[selectedCountry.name].Cadastro.skuEquipamento.btnAdicionar}
            </Button>
          </div>
        </div>
        <table className="table table-hover">
          <thead className="table-header">
            <tr className="table_row">
              <th>#</th>
              <th>{language[selectedCountry.name].Cadastro.skuEquipamento.tableHeader.descricao}</th>
              <th>{language[selectedCountry.name].Cadastro.skuEquipamento.tableHeader.codigo}</th>
              <th></th>
              <th className="edit">{language[selectedCountry.name].Cadastro.skuEquipamento.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {!!equipments &&
              Object.entries(equipments).map((item) => (
                <tr key={item[1].skE_PK_idSkuEquip}>
                  <td>{item[1].skE_PK_idSkuEquip}</td>
                  <td>{item[1].skE_description}</td>
                  <td>{item[1].skE_code}</td>
                  <td></td>
                  <td className="edit">
                    <center>
                      <ModeEditIcon
                        onClick={() => {
                          setSkuequipment(item[1].skE_PK_idSkuEquip);
                          setShowModalEdit(true);
                        }}
                      />
                    </center>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {modalAdd()}
      {modalDelete()}
      {modalEdit()}
    </>
  );
}

export default SkuEquipment;
